import {
  AUTH_BOOTSTRAP_SESSION_FAILURE,
  AUTH_BOOTSTRAP_SESSION_REQUEST,
  AUTH_BOOTSTRAP_SESSION_SUCCESS,
  AUTH_CHANGE_PASSWORD_FAILURE,
  AUTH_CHANGE_PASSWORD_REQUEST,
  AUTH_CHANGE_PASSWORD_SUCCESS,
  AUTH_FETCH_ME_FAILURE,
  AUTH_FETCH_ME_REQUEST,
  AUTH_FETCH_ME_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_REGISTER_FAILURE,
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_SETUP_SUPER_ADMIN_FAILURE,
  AUTH_SETUP_SUPER_ADMIN_REQUEST,
  AUTH_SETUP_SUPER_ADMIN_SUCCESS,
  AUTH_SET_LOADING,
  AUTH_SET_USER_PROFILE,
  AUTH_UPDATE_ME_FAILURE,
  AUTH_UPDATE_ME_REQUEST,
  AUTH_UPDATE_ME_SUCCESS,
} from './actionTypes';
import { normalizeUserProfile } from '../../utils/commerce';

const PROFILE_KEY = 'sedyam_profile';

const readStoredProfile = () => {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? normalizeUserProfile(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
};

const initialState = {
  userProfile: readStoredProfile(),
  loading: true,
  pending: false,
  error: '',
};

const clearAuthError = (state) => ({
  ...state,
  error: '',
});

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload || null,
      };

    case AUTH_SET_LOADING:
      return {
        ...state,
        loading: Boolean(action.payload),
      };

    case AUTH_BOOTSTRAP_SESSION_REQUEST:
    case AUTH_LOGIN_REQUEST:
    case AUTH_REGISTER_REQUEST:
    case AUTH_FETCH_ME_REQUEST:
    case AUTH_UPDATE_ME_REQUEST:
    case AUTH_CHANGE_PASSWORD_REQUEST:
    case AUTH_SETUP_SUPER_ADMIN_REQUEST:
      return {
        ...clearAuthError(state),
        pending: true,
      };

    case AUTH_BOOTSTRAP_SESSION_SUCCESS:
      return {
        ...state,
        userProfile: action.payload?.profile || null,
        loading: false,
        pending: false,
        error: '',
      };

    case AUTH_LOGIN_SUCCESS:
    case AUTH_REGISTER_SUCCESS:
    case AUTH_FETCH_ME_SUCCESS:
    case AUTH_UPDATE_ME_SUCCESS:
      return {
        ...state,
        userProfile: action.payload?.profile || state.userProfile,
        loading: false,
        pending: false,
        error: '',
      };

    case AUTH_CHANGE_PASSWORD_SUCCESS:
    case AUTH_SETUP_SUPER_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        pending: false,
        error: '',
      };

    case AUTH_BOOTSTRAP_SESSION_FAILURE:
    case AUTH_LOGIN_FAILURE:
    case AUTH_REGISTER_FAILURE:
    case AUTH_FETCH_ME_FAILURE:
    case AUTH_UPDATE_ME_FAILURE:
    case AUTH_CHANGE_PASSWORD_FAILURE:
    case AUTH_SETUP_SUPER_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        pending: false,
        error: action.payload?.message || 'Request failed.',
      };

    case AUTH_LOGOUT:
      return {
        ...state,
        userProfile: null,
        loading: false,
        pending: false,
        error: '',
      };

    default:
      return state;
  }
}
